import {Log} from '@aboutyou/mlm';

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const clear: typeof window.localStorage.clear = () => {
  try {
    return window.localStorage.clear();
  } catch (error: unknown) {
    Log.warn('@aboutyou/utils', 'Not able to clear the local storage', {
      error: error as Error,
    });
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const getItem: typeof window.localStorage.getItem = key => {
  try {
    return window.localStorage.getItem(key);
  } catch (error: unknown) {
    Log.warn(
      '@aboutyou/utils',
      'Not able to retrieve an item from local storage',
      {
        error: error as Error,
        itemKey: key,
      },
    );
    return null;
  }
};

export const getParsedItem = (key: string) => {
  const rawValue = getItem(key);
  try {
    if (!rawValue) {
      return null;
    }

    return JSON.parse(rawValue);
  } catch (error: unknown) {
    // This error can be thrown also for malformed strings
    return rawValue;
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const removeItem: typeof window.localStorage.removeItem = key => {
  try {
    return window.localStorage.removeItem(key);
  } catch (error: unknown) {
    Log.warn(
      '@aboutyou/utils',
      'Not able to remove an item from local storage',
      {
        error: error as Error,
        itemKey: key,
      },
    );
  }
};

// eslint-disable-next-line ssr-friendly/no-dom-globals-in-module-scope
export const setItem: typeof window.localStorage.setItem = (key, value) => {
  try {
    return window.localStorage.setItem(key, value);
  } catch (error: unknown) {
    Log.warn('@aboutyou/utils', 'Not able to set an item into local storage', {
      error: error as Error,
      itemKey: key,
    });
  }
};
